import {
  createUserWithEmailAndPassword,
  getAuth,
  sendEmailVerification,
  signInAnonymously,
  signInWithEmailAndPassword,
  updateProfile,
  getIdToken
} from "firebase/auth";
import fetchUpdateUser from "./fetch-update-user";
import { getFirebase } from "./firebase";

export async function signInAnon() {
  getFirebase();
  const auth = getAuth();
  try {
    await signInAnonymously(auth);
  } catch (error: any) {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.error({
      errorCode,
      errorMessage
    });
  }
}

export async function signInEmail(email: string, password: string) {
  getFirebase();
  const auth = getAuth();
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (error: any) {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.error({
      errorCode,
      errorMessage
    });
    throw error;
  }
}

export type UserPartial = {
  email: string;
  password: string;
  displayName: string;
};

export async function createUserFromEmail({
  email,
  password,
  displayName
}: UserPartial) {
  const auth = getAuth();
  try {
    console.info("Creating user");
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    // Signed in
    const user = userCredential.user;
    console.info("user created", { user });
    await updateProfile(user, {
      displayName
    });
    console.info("User updated");
    const [_, idToken] = await Promise.all([
      sendEmailVerification(user),
      getIdToken(user)
    ]);
    await fetchUpdateUser(idToken);
  } catch (error: any) {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.error({
      errorCode,
      errorMessage
    });
  }
}
